import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import DataTable from 'react-data-table-component';
import { FaFilePdf } from 'react-icons/fa';
import { getDisplayName } from '../components/utils';
import { Button } from 'react-bootstrap';
import AppNavbar from '../components/Navbar';

const Controls = ({
  document,
  username,
  password,
  documents,
  setDocuments
}) => {
  const modifyDocument = (action) => {
    fetch(`/api/documents/${document.hexid}/${action}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Basic ' + btoa(username + ':' + password)
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (action === 'delete') {
          setDocuments(documents.filter((d) => d.id !== document.id));
        } else if (action === 'approve') {
          setDocuments(
            documents.map((d) =>
              d.id === document.id ? { ...document, approved: true } : d
            )
          );
        } else if (action === 'unapprove') {
          setDocuments(
            documents.map((d) =>
              d.id === document.id ? { ...document, approved: false } : d
            )
          );
        }

        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  return (
    <>
      {document.approved ? (
        <Button variant="warning" onClick={() => modifyDocument('unapprove')}>
          Un-approve
        </Button>
      ) : (
        <Button variant="success" onClick={() => modifyDocument('approve')}>
          Approve
        </Button>
      )}
      <Button variant="danger" onClick={() => modifyDocument('delete')}>
        Delete
      </Button>
    </>
  );
};

Controls.propTypes = {
  document: PropTypes.shape({
    id: PropTypes.number,
    hexid: PropTypes.string,
    approved: PropTypes.bool
  }),
  username: PropTypes.string,
  password: PropTypes.string,
  documents: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })),
  setDocuments: PropTypes.func
};

const AdminPage = () => {
  const [documents, setDocuments] = useState([]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // TODO: need another enpoint that includes un-approved guidelines
  useEffect(() => {
    fetch('/api/documents/admin', {
      headers: {
        Authorization: 'Basic ' + btoa(username + ':' + password)
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setDocuments(data.documents);
      });
  }, [username, password]);

  useEffect(() => {
    setUsername(prompt('Username'));
    setPassword(prompt('Password'));
  }, []);

  const columns = [
    {
      name: 'Title',
      selector: 'title',
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <b>{getDisplayName(row)}</b>&nbsp;{' '}
          <a
            href={`/api/uploads/${document.id}/${row.filename}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFilePdf />
          </a>
        </>
      )
    },
    {
      name: 'Approved',
      selector: 'version',
      sortable: true,
      cell: (row) => (row.approved ? 'Yes' : 'No')
    },
    {
      name: 'Action',
      selector: 'edit_date',
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <Controls
          document={row}
          username={username}
          password={password}
          documents={documents}
          setDocuments={setDocuments}
        />
      )
    }
  ];

  return (
    <>
      <AppNavbar />
      <h1>Admin Page</h1>

      <DataTable
        title="Uploaded Guidelines"
        columns={columns}
        data={documents}
        fixedHeader
      />
    </>
  );
};

export default AdminPage;
